export default __webpack_public_path__ + "static/media/photo success.93dd8f4d.png";